const moment = require('moment-timezone');

export const formatTimestamp = (timestamp, format, timezone = 'UTC') => {
    // Timestamp ko given timezone ke hisaab se set karna
    return moment.tz(timestamp, timezone).format(format);
};